import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import IdCardLayer from "../components/IdCardLayer";

const IdCardPage = () => {
  return (
    <>
      <MasterLayout>
        <IdCardLayer />
      </MasterLayout>
    </>
  );
};

export default IdCardPage;
